import type { PriceTier } from '@vy/types';
import React from 'react';
import { UsageProductVariantTableEdit } from './UsageProductVariantTableEdit/UsageProductVariantTableEdit';

type UsageProductVariantTableProps = {
  tiers: Partial<PriceTier>[];
  productIndex: number;
  productVariantIndex: number;
  isFlatRate?: boolean;
  isChunked?: boolean;
};

export const UsageProductVariantTable: React.FC<UsageProductVariantTableProps> = ({
  tiers,
  productIndex,
  productVariantIndex,
  isFlatRate = false,
  isChunked = false,
}) => {
  return (
    <UsageProductVariantTableEdit
      tiers={tiers}
      isFlatRate={isFlatRate}
      isChunked={isChunked}
      productIndex={productIndex}
      productVariantIndex={productVariantIndex}
    />
  );
};
